import { AxiosService } from './axiosService';

export class ConnectorMappingService extends AxiosService {
    async getConnectors(groupId) {
        try {
            const { data } = await this.axios.get(`/connector/${groupId}/connectors`);
            return data?.data || [];
        } catch (e) {
            if (e?.response?.status !== 401) {
                throw e;
            }
        }
        return [];
    }

    async getDevices(groupId, connectorId) {
        try {
            const { data } = await this.axios.get(`/connector/${groupId}/devices`, {
                params: { connectorId }
            });
            return data?.data || [];
        } catch (e) {
            if (e?.response?.status !== 401) {
                throw e;
            }
        }
        return [];
    }

    async getPoints(groupId, connectorId, deviceId = null, unmappedOnly = false) {
        try {
            const params = { connectorId, unmappedOnly };
            if (deviceId) {
                params.deviceId = deviceId;
            }
            const { data } = await this.axios.get(`/connector/${groupId}/points`, { params });
            return data?.data || [];
        } catch (e) {
            if (e?.response?.status !== 401) {
                throw e;
            }
        }
        return [];
    }

    async mapPoint(groupId, connectorPointId, equipmentPointId) {
        try {
            await this.axios.post(`/connector/${groupId}/map`, {
                connectorPointId,
                equipmentPointId
            });
            return true;
        } catch (e) {
            console.error('Failed to map point:', e);
            return false;
        }
    }

    async unmapPoint(groupId, connectorPointId) {
        try {
            await this.axios.post(`/connector/${groupId}/unmap`, {
                connectorPointId
            });
            return true;
        } catch (e) {
            console.error('Failed to unmap point:', e);
            return false;
        }
    }

    async getLogs(groupId, connectorId, limit = 100, offset = 0, level = null) {
        try {
            const params = { limit, offset };
            if (level) {
                params.level = level;
            }
            const { data } = await this.axios.get(`/connector/${groupId}/connectors/${connectorId}/logs`, { params });
            return {
                logs: data?.data || [],
                totalCount: data?.totalCount || 0
            };
        } catch (e) {
            if (e?.response?.status !== 401) {
                throw e;
            }
        }
        return { logs: [], totalCount: 0 };
    }
}

export const connectorMappingService = new ConnectorMappingService();
